// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (c) 2026 Password Manager contributors
/**
 * Extensions index — redirects to the pairing page.
 *
 * `/dashboard/extensions` has no content of its own; the actionable page is
 * `/dashboard/extensions/pair` (also the URL the browser extension opens).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_auth/dashboard/extensions/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/extensions/pair" });
  },
});
